import { Box, type SxProps } from '@mui/material';
import type { PartnerDetails } from '../../hooks/useGetPartnerInformation';
import { DefaultTeamLogo } from './DefaultTeamLogo';

interface Props {
  sx?: SxProps;
  defaultLogoWidth?: number;
  logoUri?: PartnerDetails['logoUri'];
  legalName?: PartnerDetails['legalName'];
}

export const TeamLogo = ({
  logoUri,
  legalName,
  sx,
  defaultLogoWidth = 75,
}: Props) =>
  logoUri ? (
    <Box component="img" sx={sx} alt={`${legalName} logo`} src={logoUri} />
  ) : (
    <Box sx={sx}>
      <DefaultTeamLogo width={defaultLogoWidth} />
    </Box>
  );
